import { render, staticRenderFns } from "./work-calendar-detail.vue?vue&type=template&id=6d5c46da&scoped=true"
import script from "./work-calendar-detail.vue?vue&type=script&lang=js"
export * from "./work-calendar-detail.vue?vue&type=script&lang=js"
import style0 from "./work-calendar-detail.vue?vue&type=style&index=0&id=6d5c46da&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d5c46da",
  null
  
)

export default component.exports